/* globals angular */
(function () {
  'use strict';

  var terms = {
    template: require('./terms.html'),
    controller: 'TermsCtrl',
  };

  angular
    .module('mandaeApp')
    .component('terms', terms)
    .config(['$stateProvider', function ($stateProvider) {
      $stateProvider
        .state('termos-de-uso', {
          parent: 'finalizar-cadastro',
          component: 'terms',
          url: '/termos-de-uso',
          params: {
            user: null,
          },
        });
    }]);

}());
